"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function btm(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M8.12025 11.532L6.8115 14.3055L7.4205 16.5795L8.97 16.9935L10.893 18.9188L10.314 19.5L5.73 18.27L4.5 13.686L5.4225 12.765L9.429 8.75775L8.12025 11.532L6.8115 14.3055L10.893 10.224L9.429 8.75775L8.12025 11.532ZM10.224 13.107L14.3055 17.1885L16.5795 16.5795L16.995 15.03L18.9188 13.107L19.5 13.686L18.2715 18.2715L13.686 19.5L8.75925 14.571L10.224 13.107ZM13.776 10.893L9.6945 6.8115L7.419 7.4205L7.005 8.96775L5.08125 10.893L4.5 10.314L5.73 5.7285L10.314 4.5L11.235 5.4225L15.24 9.4275L13.776 10.893ZM15.03 7.005L13.107 5.08125L13.686 4.5L18.2715 5.7285L19.5 10.314L14.571 15.2407L13.107 13.776L17.19 9.693L16.5795 7.419L15.03 7.005Z", fill: color }));
}
exports["default"] = btm;
//# sourceMappingURL=btm.js.map